/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 02/05/2023.
 */
import { Button } from 'antd'
import React, { Suspense, useState } from 'react'
import { Link, Route, Routes, useParams } from 'react-router-dom'
import { SubpageNavigator } from '../../components/navigator/SubpageNavigator'
import { DeviceDetails } from './DeviceDetails'
import { SubjectAuditTrial } from './SubjectAuditTrial'

import { DrawerContainer } from '../../components/drawer/DrawerContainer'
import { SpinnerFullHeight } from '../../components/spinner/SpinnerFullHeight'
import { useEligibleAssignments } from '../../hooks/useEligibleAssignments'
import { useMe } from '../../hooks/useMe'
import { useProjectById } from '../../hooks/useProjectById'
import { useSubject } from '../../hooks/useSubject'
import { authStore } from '../../store/auth/authStore'
import { PROJECT_STATES, SUBJECT_STATUS_ENUM, SubjectType, USER_TYPES } from '../../Types'
import { SubjectIMPModal } from './modals/SubjectIMPModal'
import { SubjectAssignment } from './SubjectAssignment'
import { SubjectAssignments } from './SubjectAssignments'
import { SubjectDetailsView } from './SubjectDetailsView'
import { SubjectEligibilityView } from './SubjectEligibilityView'
import { SubjectPii } from './SubjectPII'
import { useGroups } from '../../hooks/useGroups'
import { COLOR, COLOR_PRIMARY } from '../../constants'
import { MoveDrawer } from './move/MoveDrawer'
import { TerminateSubjectDrawer } from './move/TerminateSubjectDrawer'
import { ReactivateSubjectDrawer } from './move/ReactivateSubjectDrawer'
import {
  ASSESS_ELIGIBILITY_ROUTE,
  DEVICE_UNAVAILBLE_ROUTE,
  ELIGIBILITY,
  MOVE_SUBJECT_BACK,
  UNCOMPLETE_ROUTE,
  UPDATE_SUBJECT_ROUTE,
} from '../../routes'
import { SubjectAssessEligibilityView } from './SubjectAssessEligibilityView'
import { MovePreviousDrawer } from './subject_update/MovePreviousDrawer'
import { UnCompleteDrawer } from './subject_update/UnCompleteDrawer'
import { DeviceUnAvailable } from './DeviceUnAvailable'
import { DependencyAssignmentView } from './dependency-view/DependencyAssignmentView'
import { NotificationBanner } from '../../components/display/NotificationBanner'

export const SubjectView = () => {
  const { projectId, subjectId } = useParams() as { subjectId: string; projectId: string }
  const userAtt = authStore((state) => state.user?.attributes)

  const { data: subjectData, mutate: mutateSubjectData } = useSubject(projectId, subjectId)
  const { data: projectData } = useProjectById(projectId)

  const subpageMenu = [`Overview`, 'Device', 'Audit trail', 'Personal Information']

  const closeDrawer = () => {}

  // TODO - fix this - you should not look in the user type
  const showUpdateBtn = userAtt?.['custom:userType'] !== 'CLINICIAN' || projectData.status !== PROJECT_STATES.ACTIVE

  return (
    <>
      <div className="container-fluid bg-white ">
        <div className="container pt-5 pb-4 px-lg-6">
          <SubjectDetailsView
            subjectData={subjectData}
            child={
              !showUpdateBtn ? (
                <div className="">
                  <Link to={UPDATE_SUBJECT_ROUTE.to}>
                    <Button
                      className=""
                      type="primary"
                      disabled={
                        userAtt?.['custom:userType'] !== 'CLINICIAN' || projectData.status !== PROJECT_STATES.ACTIVE
                      }
                    >
                      Update Participant Status
                    </Button>
                  </Link>
                </div>
              ) : null
            }
          ></SubjectDetailsView>
        </div>
      </div>

      <SubpageNavigator menu={subpageMenu}>
        <SubjectOverview subjectData={subjectData}></SubjectOverview>

        <DeviceDetails></DeviceDetails>

        <SubjectAuditTrial></SubjectAuditTrial>

        <SubjectPii me={userAtt}></SubjectPii>
      </SubpageNavigator>

      <Routes>
        {/*

        NEEDS CLEANUP - OLD UPDATE FUNCTIONALITY
        all the content of SubjectUpdateWrapper shouold be deleted

        */}

        <Route
          path="/assignment/:assignmentId/*"
          element={
            <>
              <DrawerContainer
                bodyStyle={{ padding: '0 0 0 0' }}
                projectId={projectId}
                setVisible={closeDrawer}
                width={'50%'}
                to="../"
                title="Participant answers"
              >
                <SubjectAssignment subjectLanguageIsoCode={subjectData.language.toLowerCase()}></SubjectAssignment>
              </DrawerContainer>
              <Routes>
                <Route
                  path="/dependency"
                  element={
                    <DrawerContainer
                      projectId={projectId}
                      setVisible={closeDrawer}
                      width={'80%'}
                      to="../"
                      title="Questionnaire details"
                    >
                      <DependencyAssignmentView
                        subjectLanguageIsoCode={subjectData.language.toLowerCase()}
                      ></DependencyAssignmentView>
                    </DrawerContainer>
                  }
                />
              </Routes>
            </>
          }
        />

        <Route
          path={ELIGIBILITY.path}
          element={
            <DrawerContainer
              projectId={projectId}
              setVisible={closeDrawer}
              width={'100%'}
              to="../"
              title="Questionnaire details"
            >
              <SubjectEligibilityView></SubjectEligibilityView>
            </DrawerContainer>
          }
        />
        <Route
          path={ASSESS_ELIGIBILITY_ROUTE.path}
          element={
            <DrawerContainer
              projectId={projectId}
              setVisible={closeDrawer}
              width={'60%'}
              to="../"
              title="Assess Eligibility"
              bodyStyle={{ background: COLOR.BACKGROUND_GRAY }}
            >
              <SubjectAssessEligibilityView></SubjectAssessEligibilityView>
            </DrawerContainer>
          }
        />

        {/*

        NEW UPDATE AND ELIGIBILITY DRAWER

        */}

        <Route
          path={UPDATE_SUBJECT_ROUTE.path}
          element={
            <Suspense fallback={<SpinnerFullHeight></SpinnerFullHeight>}>
              <MoveDrawer subjectData={subjectData} onClose={closeDrawer}></MoveDrawer>
            </Suspense>
          }
        />

        <Route
          path="terminate"
          element={
            <DrawerContainer projectId={projectId} width={400} to="../" title="Terminate Participant">
              <TerminateSubjectDrawer subject={subjectData}></TerminateSubjectDrawer>
            </DrawerContainer>
          }
        />

        <Route
          path="reactivate"
          element={
            <DrawerContainer projectId={projectId} width={400} to="../" title="Reactivate Participant">
              <ReactivateSubjectDrawer subject={subjectData}></ReactivateSubjectDrawer>
            </DrawerContainer>
          }
        />

        <Route
          path={UNCOMPLETE_ROUTE.path}
          element={
            <DrawerContainer projectId={projectId} width={400} to="../" title="Uncomplete Participant">
              <UnCompleteDrawer subject={subjectData} mutateSubjectData={mutateSubjectData}></UnCompleteDrawer>
            </DrawerContainer>
          }
        />

        <Route
          path={DEVICE_UNAVAILBLE_ROUTE.path}
          element={
            <DrawerContainer projectId={projectId} width={400} to="../" title="Device Unavailable">
              <DeviceUnAvailable></DeviceUnAvailable>
            </DrawerContainer>
          }
        />

        <Route
          path={MOVE_SUBJECT_BACK.path}
          element={
            <DrawerContainer projectId={projectId} width={410} to="../" title="Move Participant Back">
              <MovePreviousDrawer subjectData={subjectData} onClose={closeDrawer}></MovePreviousDrawer>
            </DrawerContainer>
          }
        />
      </Routes>
    </>
  )
}

const SubjectOverview = ({ subjectData }: { subjectData: SubjectType }) => {
  const { projectId, subjectId } = useParams() as { projectId: string; subjectId: string }

  /**
   * TODO: Make eligibility button in its own component - WIP WIP WIP
   */

  const me = useMe(projectId)
  const eligibleAssignments = useEligibleAssignments(projectId, subjectId)

  const { data: groups, mutate: mutateGroups } = useGroups(projectId, subjectId)

  const [isIMPOpen, setIsIMPOpen] = useState(false)

  const showIMPModal = () => {
    setIsIMPOpen(true)
  }

  return (
    <div className="container ">
      <Routes>
        <Route
          path="/imp/:groupId"
          element={
            <SubjectIMPModal
              subjectData={subjectData}
              isIMPOpen={isIMPOpen}
              setIMPOpen={setIsIMPOpen}
              mutate={mutateGroups}
            ></SubjectIMPModal>
          }
        />
      </Routes>

      <NotificationBanner className="mb-4" variant="SUBJECT_VIEW"></NotificationBanner>

      {me.data.type === USER_TYPES.CLINICIAN && eligibleAssignments.data ? (
        <div className="row px-0" style={{}}>
          <div
            className="col-12 mb-2 px-4 d-flex justify-content-between  align-items-center rounded-2 py-3"
            style={{ background: '#e7f3ff' }}
          >
            <div className="">
              <p className="mb-0 mt-1 p-small" style={{ color: '#346ca8' }}>
                Click <span className="fw-bolder">"Assess Eligibility"</span> to check eligibility calculations for this
                participant.
              </p>
            </div>
            <div>
              {/*  <Link className="me-3" to={ELIGIBILITY.to}>
                <Button type="primary">View Eligibility</Button>
              </Link>*/}

              <Link to={ASSESS_ELIGIBILITY_ROUTE.to}>
                <Button type="default" style={{ border: `1px solid ${COLOR_PRIMARY}`, color: '#0252cd' }}>
                  Assess Eligibility
                </Button>
              </Link>
            </div>
          </div>
        </div>
      ) : null}

      {me.data.type === USER_TYPES.CLINICIAN &&
      groups.length > 0 &&
      subjectData.onboard === 'ONBOARDED_COMPLETED' &&
      subjectData.status === SUBJECT_STATUS_ENUM.ACTIVE
        ? groups.map((group, index) => {
            return (
              <div key={index} className="row px-0" style={{}}>
                <div
                  className="col-12 d-flex justify-content-center mb-2 px-4 rounded-2 py-4"
                  style={{ background: '#e7f3ff' }}
                >
                  <div className="">
                    <p className="mb-0 fw-bold mt-1 text-center" style={{ color: '#346ca8' }}>
                      {group.cta.title || '---'}
                    </p>
                    <p className="mb-0 mt-1 mb-2 p-small text-center" style={{ color: '#346ca8' }}>
                      {group.cta.description}
                    </p>

                    <div className="d-flex justify-content-center">
                      <Link to={'imp/' + group._id}>
                        <Button type="primary" onClick={showIMPModal}>
                          {group.cta.label}
                        </Button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            )
          })
        : null}

      <div className="row" style={{}}>
        <Suspense
          fallback={
            <SpinnerFullHeight fullHeight={true}>
              <p className="p-small mt-1">Loading Assigments</p>
            </SpinnerFullHeight>
          }
        >
          <SubjectAssignments
            subjectLanguageIsoCode={subjectData.language.toLowerCase()}
            subjectStatus={subjectData.status}
          />
        </Suspense>
      </div>
    </div>
  )
}
